import {Icon, IconButton, makeStyles, Typography} from "@material-ui/core";
import TypeEntity from "../../../../../../../Utils/Form/FormDynamic/Fields/EntityExternal/Entity";
import DefaultType from "../../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import ContextMenu from "../../../TableRenderingComponent/ContextMenu";
import {useCallback, useEffect, useMemo, useState} from "react";

const initialContextState = {
    mouseX: null,
    mouseY: null,
    index: null
};
const useStyles = makeStyles(() => ({
    tableContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        border: '1px solid #ccc',
        borderRadius: 8
    },
    headRow: {
        display: 'flex',
        fontWeight: 'bold',
        borderBottom: '1px solid #ccc',
        alignItems: 'center',
        borderRadius: '8px 8px 0 0',
        background: 'rgb(188, 214, 255)'
    },
    defaultCell: {flex: 1, padding: '5px'},
    cellWithBorder: {flex: 1, padding: '5px', borderLeft: '1px solid #ccc'},
    disabledBlock: {
        flex: 1,
        borderLeft: '1px solid #ccc',
        background: '#f7f7f7',
        border: '10px solid transparent',
        display: 'flex',
        alignItems: 'center'
    }
}))
const PointsConditions = ({values, removeGroup, addGroup, path, onChangeFields}) => {
    const classes = useStyles();
    const [contextMenu, setContextMenu] = useState(initialContextState);
    const [fieldType, setFieldType] = useState(null)

    useEffect(() => {
        if (values?.field?.type) {
            setFieldType(values.field.type)
        }
    }, [values?.field?.type]);

    const isRangeIncluded = useMemo(() => {
        if (!values.pointsConditions) return false
        return Boolean(values.pointsConditions.find(v => v.operand === 'range' || v.operand === 'notRange'))
    }, [JSON.stringify(values)])

    const openContextMenu = useCallback((e, index) => {
        setContextMenu({mouseX: e.clientX - 2, mouseY: e.clientY - 4, index})
    }, [])

    const closeContextMenu = useCallback(() => {
        setContextMenu(initialContextState)
    }, [])

    const addOneRow = useCallback((index, direction) => {
        addGroup(index + direction);
    }, [JSON.stringify(values), path]);

    const removeOneRow = useCallback((index) => {
        // if (values.length === 1) {
        //     setValue([{}], path)
        //     return
        // }
        removeGroup(index)
    }, [path, JSON.stringify(values)]);
    const CurrentField = useCallback(({type, path}) => {
        if (!type) {
            return <div className={classes.disabledBlock}>

            </div>
        }

        if (type === 'entityExternal') {
            return <TypeEntity
                values={values}
                setValue={onChangeFields}
                field={{
                    entity: values.field.entity,
                    path,
                    label: "Field",
                }}
                fieldStyles={{
                    fullWidth: true,
                    withoutStyles: true,
                    hideLabel: true
                }}
                labelStyles={{width: 0}}
            />
        }
        return <DefaultType
            values={values}
            setValue={onChangeFields}
            field={{
                type,
                path,
                label: "Field",
            }}
            fieldStyles={{
                fullWidth: true,
                withoutStyles: true,
                hideLabel: true
            }}
            labelStyles={{width: 0}}
        />
    }, [JSON.stringify(values)])
    return (
        <div>
            <div className={classes.tableContainer}>
                <div className={classes.headRow}>
                    <div className={classes.defaultCell}>Operand</div>
                    <div className={classes.cellWithBorder}>Value</div>
                    {isRangeIncluded && (
                        <div className={classes.cellWithBorder}>Value2</div>
                    )}

                    <div className={classes.cellWithBorder}>Points</div>
                    <div style={{width: 30}}>

                    </div>
                </div>
                {(values?.pointsConditions || [{}]).map((item, index) => {
                    return (
                        <div key={index}
                             style={{
                                 display: 'flex',
                                 borderBottom: '1px solid #eee',
                                 borderRadius: '0 0 8px 8px ',
                             }}>
                            <div style={{flex: 1, display: 'flex', alignItems: 'center'}}>
                                <TypeEntity
                                    values={values}
                                    setValue={onChangeFields}
                                    field={{
                                        path: `pointsConditions.${index}.operand`,
                                        label: "Entity",
                                        entity: 'operand'
                                    }}
                                    fieldStyles={{
                                        fullWidth: true,
                                        withoutStyles: true,
                                        hideLabel: true
                                    }}
                                    labelStyles={{width: 0}}
                                />
                            </div>
                            <div style={{flex: 1, borderLeft: '1px solid #ccc', display: 'flex', alignItems: 'center'}}>
                                <CurrentField
                                    path={`pointsConditions.${index}.value`}
                                    type={fieldType}
                                />
                            </div>
                            {isRangeIncluded && (
                                <div style={{
                                    flex: 1,
                                    borderLeft: '1px solid #ccc',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    {item.operand === 'range' || item.operand === 'notRange' ? (
                                        <CurrentField
                                            path={`pointsConditions.${index}.value2`}
                                            type={fieldType}
                                        />
                                    ) : <div className={classes.disabledBlock}></div>}

                                </div>
                            )}

                            <div style={{flex: 1, borderLeft: '1px solid #ccc', display: 'flex', alignItems: 'center'}}>
                                <DefaultType
                                    values={values}
                                    setValue={onChangeFields}
                                    field={{
                                        type: 'number',
                                        path: `pointsConditions.${index}.points`,
                                        label: "Field",
                                    }}
                                    fieldStyles={{
                                        fullWidth: true,
                                        withoutStyles: true,
                                        hideLabel: true
                                    }}
                                    labelStyles={{width: 0}}
                                />
                            </div>
                            <div style={{
                                width: 30,
                                borderLeft: '1px solid #ccc',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <IconButton size={'small'} onClick={(e) => openContextMenu(e, index)}>
                                    <Icon fontSize={"small"}>more_vert</Icon>
                                </IconButton>
                            </div>
                        </div>
                    )
                })}
            </div>
            <ContextMenu
                contextMenu={contextMenu}
                onClose={closeContextMenu}
                removeItem={removeOneRow}
                addItem={addOneRow}
            />
        </div>

    )
}

export default PointsConditions